import { zodResolver } from '@hookform/resolvers/zod'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { AAKeywordInput } from '../../../lib/types/models/aa-keywords/aa-keyword-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import Form, { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<AAKeywordInput> = z.object({
  label: createStringSchema('label')
})

const AAKeywordForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<AAKeywordInput>) => {
  const form = useForm<AAKeywordInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form form={form}>
      <form
        className="flex flex-col gap-4"
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
      >
        <Box className="flex flex-col gap-4">
          <Typography variant="body-medium" color={tailwindColors.primary.DEFAULT}>
            AA
          </Typography>
          <FormField
            control={form.control}
            name="label"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} required label="Label" type="text" />
                </FormControl>
              </FormItem>
            )}
          />

          <ValidationButtons {...validationButtonProps} />
        </Box>
      </form>
    </Form>
  )
}

export default AAKeywordForm
